import React from 'react';
import './ITSoftware.css';

function MediaEntertainment() {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/media_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Media & Entertainment</h1>
          <p>Creative industry solutions covering finance, contracts, IP, and royalties</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Supporting the Business Behind the Talent</h2>
          <p>We help creators, agencies, and production houses with financial planning, GST on digital rights, and regulatory contracts.</p>
          <p>From influencer taxation to OTT royalty structuring, we provide modern tax and legal tools for content monetization.</p>
          <p>Navigate film financing, ad revenue accounting, and brand deal contracts with ease and confidence.</p>
          <p>Our team assists with entity setup for creators, IP protection, and digital media-specific advisory.</p>
        </div>
        <div className="content-right">
          <img src="/images/media.jpg" alt="Media & Entertainment" />
        </div>
      </section>
    </div>
  );
}

export default MediaEntertainment;
